const vorstandData = {
  intro: `Der Vorstand des Anglervereins „Angelfreunde 1866 e.V.“ setzt sich aus ehrenamtlichen Mitgliedern zusammen. 
  Er besteht aus dem geschäftsführenden Vorstand mit Paul, Micha und Marion. Und darüber hinaus aus sechs weiteren Funktionsinhabern. 
  Sie alle haben die Aufgabe, die Interessen des Vereins zu vertreten. 
  Mit großer Einsatzfreudigkeit arbeiten alle Vorstandsmitglieder in den anvertrauten jeweiligen Aufgabengebieten 
  und sorgen so mit ihrem persönlichen Engagement und den dabei eingebrachten eigenen Ideen für ein interessantes Vereinsleben.`,
  members: [
    {
      name: "Paul",
      role: "1. Vorsitzender",
      image: "/Vorstand/Vorstand_Paul.jpeg",
      alt: "Portrait von Paul, 1. Vorsitzender",
      title: "Paul – 1. Vorsitzender"
    },
    {
      name: "Micha",
      role: "Stellvertretender Vorsitzender",
      image: "/Vorstand/Vorstand_Micha.JPG",
      alt: "Portrait von Micha, Stellvertretender Vorsitzender",
      title: "Micha – Stellvertretender Vorsitzender"
    },
    {
      name: "Marion",
      role: "Hauptkassiererin",
      image: "https://placehold.co/300x400?text=/",
      alt: "Portrait von Marion, Hauptkassiererin",
      title: "Marion – Hauptkassiererin"
    },
    {
      name: "Evi",
      role: "Kassiererin",
      image: "/Vorstand/Vorstand_Evi.JPG",
      alt: "Portrait von Evi, Kassiererin",
      title: "Evi – Kassiererin"
    },
    {
      name: "Jolina",
      role: "Schriftführerin",
      image: "/Vorstand/Vorstand_Jolina.JPG",
      alt: "Portrait von Jolina Marie, Schriftführerin",
      title: "Jolina Marie – Schriftführerin"
    },
    {
      name: "Kurt",
      role: "Gosenwart",
      image: "/Vorstand/Vorstand_Kurt.JPG",
      alt: "Portrait von Kurt, Grundmittelverwalter",
      title: "Kurt – Gosenwart"
    },
    {
      name: "Uwe",
      role: "2. Gosenwart / Jugend",
      image: "/Vorstand/Vorstand_Uwe.JPG",
      alt: "Portrait von Uwe, 2. Gosenwart / Jugend",
      title: "Uwe – 2. Gosenwart / Jugend"
    },
    {
      name: "Robert",
      role: "Sportwart",
      image: "/Vorstand/Vorstand_Robert.jpeg",
      alt: "Portrait von Robert, Sportwart",
      title: "Robert – Sportwart"
    },
    {
      name: "Mandy",
      role: "Chronikführerin",
      image: "https://placehold.co/300x400?text=/",
      alt: "Portrait von Mandy, Chronikführerin",
      title: "Mandy – Chronikführerin"
    }
  ],
};

export default vorstandData;